import { useMemo, useState } from "react";
import {
  List,
  NumberField,
  TextField,
  WrapperField,
  DatagridConfigurable,
  WithRecord,
  BulkDeleteWithConfirmButton,
  usePermissions,
} from "react-admin";
import BrandPriceAdditionAddDialog from "../../components/brandPriceAdditions/create/BrandPriceAdditionAddDialog";
import BrandPriceAdditionEditDialog from "../../components/brandPriceAdditions/edit/BrandPriceAdditionEditDialog";
import brandPriceAdditionFilterList from "../../components/brandPriceAdditions/filter/brandPriceAdditionFilterList";
import EditBtn from "../../components/editBtn/EditBtn";
import TableListActions from "../../components/tableListActions/TableListActions";

const BrandPriceAdditionList = () => {
  const { permissions } = usePermissions();
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [recordId, setRecordId] = useState();

  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };
  const handleClickOpenEdit = (recId) => () => {
    setRecordId(recId);
    setOpenEdit(true);
  };
  const list = useMemo(
    () => (
      <List
        empty={false}
        actions={
          <TableListActions
            createHandler={handleClickOpenAdd}
            exporter={false}
          />
        }
        filters={brandPriceAdditionFilterList(permissions)}
        queryOptions={{ meta: { sort: ["price ASC"] } }} // overide default sort
      >
        <DatagridConfigurable
          bulkActionButtons={<BulkDeleteWithConfirmButton />}
        >
          {permissions && permissions.update_company ? (
            <TextField label="mine.label.company" source="company.alias" />
          ) : null}
          <TextField label="mine.label.brand" source="brand.name" />
          <NumberField source="price" label="mine.label.price" />
          <WrapperField label="mine.label.actions" textAlign="center">
            <WithRecord
              label="author"
              render={(record) => {
                return <EditBtn editHandler={handleClickOpenEdit(record.id)} />;
              }}
            />
          </WrapperField>
        </DatagridConfigurable>
      </List>
    ),
    [permissions]
  );
  return (
    <>
      {list}
      <BrandPriceAdditionAddDialog open={openAdd} setOpen={setOpenAdd} />
      <BrandPriceAdditionEditDialog
        open={openEdit}
        setOpen={setOpenEdit}
        recordId={recordId}
      />
    </>
  );
};

export default BrandPriceAdditionList;
